module.exports = __webpack_public_path__ + "img/keynote_3-sm.6562fe28.png";